
import { defineComponent } from 'vue';

import { useInsertDataStore } from '@/hooks/use_insert_data_store';

export default defineComponent({
  name: 'ContentCustomizingPurchaseItemConfirm',
  setup() {
    const { purchaseItem } = useInsertDataStore();
    const { purchaseStore } = useInsertDataStore();
    return {
      purchaseItem,
      purchaseStore,
    };
  },
});
